export function removeCodeMobile(mobile: string) {
    if (mobile.slice(0, 1) == '+') {
        const temp = mobile.substring(3, mobile.length);
        let result = "0" + temp;
        return result
    } else {
        return mobile
    }
}